module.exports = __webpack_public_path__ + "img/27_89.4a5d7cff.png";